(() => {
  if (window.unrealPayPalCartConnected) return;
  window.unrealPayPalCartConnected = true;
  let pending = false;
  const pause = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const root = () => window.Shopify?.routes?.root || '/';
  async function fetchCart() {
    const response = await fetch(root() + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw new Error('cart');
    return response.json();
  }
  async function waitForCart() {
    await pause(400);
    for (let attempt = 0; attempt < 50; attempt += 1) {
      if (!document.querySelector('.cart__items--disabled')) return;
      await pause(100);
    }
    throw new Error('cart');
  }
  document.addEventListener('click', async (event) => {
    const button = event.target instanceof Element ? event.target.closest('[data-unreal-paypal-cart]') : null;
    if (!button || button.disabled || pending) return;
    event.preventDefault();
    pending = true;
    const message = button.closest('.unreal-paypal-cart')?.querySelector('[data-unreal-paypal-message]');
    const label = button.textContent;
    const show = (value) => {
      if (message) { message.textContent = value; message.hidden = !value; }
    };
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.textContent = button.dataset.loadingMessage;
    show('');
    try {
      await waitForCart();
      let cart = await fetchCart();
      const form = button.dataset.cartForm ? document.getElementById(button.dataset.cartForm) : null;
      const updates = {};
      for (const input of form?.querySelectorAll('input[name="updates[]"][data-index]') || []) {
        const index = Number(input.dataset.index) - 1;
        const quantity = Number(input.value);
        const line = cart.items?.[index];
        if (!line || !Number.isSafeInteger(quantity) || quantity < 0 || quantity > 20) throw new Error('fallback');
        if (line.quantity !== quantity) updates[line.key] = quantity;
      }
      if (Object.keys(updates).length) {
        const response = await fetch(root() + 'cart/update.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }),
        });
        if (!response.ok) throw new Error('cart');
        cart = await response.json();
      }
      if (!Array.isArray(cart.items) || !cart.items.length) throw new Error('empty');
      if (cart.currency !== 'AED' || Number(cart.total_discount) !== 0 || cart.items.length > 40 ||
          cart.items.some((line) => line.selling_plan_allocation || line.gift_card ||
            line.parent_relationship || line.item_components?.length ||
            Object.entries(line.properties || {}).some(([key, value]) => !key.startsWith('_') && value !== null && value !== '') ||
            !Number.isSafeInteger(line.quantity) || line.quantity < 1 || line.quantity > 20)) throw new Error('fallback');
      const items = cart.items.map((line) => {
        const id = String(line.variant_id || line.id);
        if (!/^\d{10,20}$/.test(id)) throw new Error('fallback');
        return id + ':' + line.quantity;
      }).join(',');
      if (items.length >= 2000 || !Number.isSafeInteger(cart.total_price) || cart.total_price < 100) throw new Error('fallback');
      const target = new URL(button.dataset.checkoutUrl);
      if (target.origin !== 'https://unreal-skin-paypal-checkout.dishantsahare666.chatgpt.site' || target.pathname !== '/cart') throw new Error('cart');
      target.searchParams.set('items', items);
      target.searchParams.set('shop_total', String(cart.total_price));
      target.searchParams.set('shop_currency', cart.currency);
      window.location.assign(target.href);
    } catch (error) {
      show(error.message === 'empty' ? button.dataset.emptyMessage :
        error.message === 'fallback' ? button.dataset.fallbackMessage : button.dataset.errorMessage);
    } finally {
      pending = false;
      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.textContent = label;
    }
  });
})();
